import {deletePopover} from "../../../hoc/deletePopover";

const CashBoxTransferDeleteModal = deletePopover("CashBoxTransferDeleteModal")

export default CashBoxTransferDeleteModal
